import { APIOptionsWithoutAPIClass, useAPI } from "./useAPI";
import { ControlCenterSettingsApi } from "../../client-control-center";

export const useControlCenterSettingsAPI = <T>({
  initialValue,
  handleRequest,
}: APIOptionsWithoutAPIClass<T, ControlCenterSettingsApi>) => {
  return useAPI<T, ControlCenterSettingsApi>({
    initialValue,
    APIClass: ControlCenterSettingsApi,
    handleRequest,
  });
};
